import { useEffect, useState } from 'react'

/** Hora actual que se refresca cada `everyMs` (cuentas atrás). */
export function useNow(everyMs = 60000): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), everyMs)
    return () => clearInterval(id)
  }, [everyMs])
  return now
}
